import { DashboardCardTemplate, DashboardCardTemplateProps } from "./template";

export type DashboardCardProps = DashboardCardTemplateProps;

export const DashboardCard = (props: DashboardCardProps): JSX.Element => {
  return <DashboardCardTemplate {...props} />;
};
